import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-done",
  "use": "icon-done-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol viewBox=\"0 0 12 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-done\">\n    <path d=\"M0 5.42539L4.10933 10L12 1.24129L10.8672 0L4.10933 7.49995L1.11715 4.17535L0 5.42539Z\" fill=\"#25CF36\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol